import Swiper, { Navigation, Autoplay } from 'swiper'

const DescriptionSlider = () => {

  // Função para inicializar ou destruir o swiper com base na largura da tela
  function toggleSwiper() {
      const windowWidth = window.innerWidth;
  
      if (windowWidth < 768 && !swiper) {
        // Inicialize o swiper se a largura da tela for menor que 768 e o swiper ainda não tiver sido iniciado
        swiper = new Swiper('.description_slider', {
          modules: [Autoplay, Navigation],
          
          slidesPerView: 1,
              
          autoplay: {
            delay: 3500,
          },
      
          navigation: {
            nextEl: '.description_slider_slider .slider-button-next',
            prevEl: '.description_slider_slider .slider-button-prev',
          },
        })
      } else if (windowWidth >= 768 && swiper) {
        // Destrua o swiper se a largura da tela for maior ou igual a 768 e o swiper ainda estiver ativo
        swiper.destroy(true, true);
        swiper = null;
      }
  }
  
  let swiper = null;
  
  // Ative ou desative o swiper na carga inicial da página
  toggleSwiper();
  
  // Adicione um ouvinte de evento de redimensionamento para ativar ou desativar o swiper dinamicamente
  window.addEventListener('resize', toggleSwiper);

}

export default DescriptionSlider
